// deps
import React, { memo } from "react";

// types
import { PLBillCtaAction, PLBillPrimitive } from "@swiggy-private/cart-types";

// styles
import { PrimitiveWrapper, PrimitiveIcon, PrimitiveButton } from "./BillPrimitives.style";

// components
import BillText from "./components/bill-text/BillText";

// constants
import { VALID_PL_BILL_DETAILS_TYPES } from "../../constants/PLBillDetails";
import { PL_BILL_PRIMITIVES_TEST_IDS } from "@swiggy-private/cart-test-ids";

interface BillPrimitivesProps {
    items: PLBillPrimitive[];
    actionMap?: Record<PLBillCtaAction, VoidFunction>;
}

const BillPrimitives = ({ items, actionMap }: BillPrimitivesProps) => (
    <PrimitiveWrapper data-testid={PL_BILL_PRIMITIVES_TEST_IDS.WRAPPER}>
        {items.map((item, idx) => {
            switch (item.type) {
                case VALID_PL_BILL_DETAILS_TYPES.ICON:
                    return (
                        <span
                            key={idx}
                            data-testid={PL_BILL_PRIMITIVES_TEST_IDS.ICON}
                            style={item.properties?.style as React.CSSProperties}
                        >
                            <PrimitiveIcon
                                cloudinaryId={item.icon}
                                alt=""
                                width={String(item.properties?.style?.width ?? "16px")}
                                height={String(item.properties?.style?.height ?? "16px")}
                            />
                        </span>
                    );

                case VALID_PL_BILL_DETAILS_TYPES.TEXT:
                    return <BillText key={idx} item={item} />;

                case VALID_PL_BILL_DETAILS_TYPES.BUTTON:
                    return (
                        <PrimitiveButton
                            key={idx}
                            data-testid={PL_BILL_PRIMITIVES_TEST_IDS.BUTTON}
                            style={item.properties?.style as React.CSSProperties}
                            variant={item.properties?.dls?.textVariant || "V2.body2.neutral.regular"}
                            color={item.properties?.dls?.textColor || "primary"}
                            onClick={item.ctaAction ? actionMap?.[item.ctaAction] : undefined}
                        >
                            {item.text}
                        </PrimitiveButton>
                    );

                default:
                    return null;
            }
        })}
    </PrimitiveWrapper>
);

export default memo(BillPrimitives);
